import { createSlice } from "@reduxjs/toolkit";

// Récupérer l'état initial depuis le localStorage s'il existe
const persistedState = localStorage.getItem("userState")
  ? JSON.parse(localStorage.getItem("userState"))
  : {};


export const initialState = {
  avatar: "",
  username: "",
  email: "",
  isEmpty: null,
  simulationRole: persistedState.simulationRole ?? false,
  initialRole:[],
  authority: [],
  roles: persistedState.roles ?? [],
  defaultAgency: "",
};

function returnAgency(agencies) {
  const agencyPersisted =
    agencies &&
    persistedState &&
    agencies.some((agency) => agency.id === persistedState.id);
  if (persistedState && persistedState.id && agencyPersisted) {
    return persistedState;
  }
  if (agencies) return agencies[0];
  return null;
}

export const userSlice = createSlice({
  name: "auth/user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const newState = {
        ...state,
        ...action.payload,
        roles: state.simulationRole ? state.roles : action.payload.roles,
        initialRole: action.payload.roles,
        isEmpty: action.payload.agencies.length === 0 ? true : false,
        defaultAgency: returnAgency(action.payload.agencies, state),
      };
      // Sauvegarder le nouvel état dans le localStorage
      localStorage.setItem("userState", JSON.stringify(newState.defaultAgency));
      return newState;
    },
    setUserRole: (state, action) => {
      if (action.payload === "RESET") {
        state.roles = state.initialRole; // Retour au rôle initial
        state.simulationRole = false;  // Désactiver la simulation correctement
      } else {
        state.roles = [action.payload];
        if (!state.simulationRole) {
          state.simulationRole = true; // Activer la simulation seulement si ce n'est pas déjà fait
        }
      }
      localStorage.setItem("userState", JSON.stringify(state));
    },
    setSimulationRole: (state, action) => {
      state.simulationRole = action.payload;
      if(action.payload === false) {
        state.roles = state.initialRole;
      }
      localStorage.setItem("userState", JSON.stringify(state)); // Sauvegarde tout l'état
    },
    setDefaultAgency: (state, action) => {
      state.defaultAgency = action.payload.defaultAgency;
      // Sauvegarder le nouvel état dans le localStorage
      localStorage.setItem(
        "userState",
        JSON.stringify(action.payload.defaultAgency)
      );
    },
    userLoggedOut: () => {
      // Supprimer l'état du localStorage lors de la déconnexion
      localStorage.removeItem("userState");
      return initialState;
    },
  },
});

export const { setUser, setDefaultAgency, userLoggedOut, setUserRole, setSimulationRole } = userSlice.actions;

export default userSlice.reducer;
